import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HeaderSmbDescription, SearchHeader, SMBName } from './Search.styles';
import { BackButton } from '../common/PageLayout.styles';
import ShipstationShopIcon from '../ShipstationShopIcon/ShipstationShopIcon';
import * as searchTypes from '../../../constants/searchTypes';
import {
  canMacroWizardCanGoBack,
  extractNoMatchPageActivated,
  extractSelectedTicketFromState,
  getSearchId,
  getSearchTypeOfSelectedAction,
  getSelectedSearchResultIndex,
  showingMacroWizard,
} from '../../../extractFromState';
import {
  getSelectedConfig,
  getSelectedShop,
  getSelectedSearchOrdersShops,
  selectSelectedToolDomains,
} from '../../../selectors/tools';
import { clearSelectedSearchResult, returnToPreviousMacroWizardPath } from '../../../actions/searchActions';
import { deselectSearchOrderShops } from '../../../actions/tools/OrdersSearchActions';
import { clearBlockingAlertViewedIds } from 'actions/tools/ToolActions';

class SearchTitle extends Component {
  handleBackClick = () => {
    // TODO: Remove state field for displayResultOfType
    // We can handle this case by just changing the selected result in redux like we do for

    if (this.props.showingMacroWizard) {
      this.props.returnToPreviousMacroWizardPath();
    } else if (this.props.searchType === searchTypes.SEARCH_ORDERS) {
      this.props.deselectSearchOrderShops();
    } else if (this.props.searchType === searchTypes.SEARCH_ALL) {
      this.props.clearBlockingAlertViewedIds();
      this.props.clearSelectedSearchResult();
    }
  };

  render() {
    const {
      selectedShop,
      noMatchPageActivated,
      selectedToolDomains,
      searchType,
      selectedConfig,
      selectedSearchResult,
      macroWizardCanGoBack,
      searchOrderShops,
    } = this.props;
    const hasMultipleShopifyStores = Object.keys(selectedToolDomains.shopifyConfigs || {}).length > 1;
    const displayShipstationIcon =
      (selectedConfig || {}).shipstataionInstalled && searchType === searchTypes.SEARCH_ORDERS;

    const searchOrdersShopSelected =
      (selectedShop || searchOrderShops) && hasMultipleShopifyStores && searchType === searchTypes.SEARCH_ORDERS;
    const searchAllResultIsOpened = selectedSearchResult !== -1 && searchType === searchTypes.SEARCH_ALL;
    const showBackButton =
      noMatchPageActivated || macroWizardCanGoBack || searchAllResultIsOpened || searchOrdersShopSelected;

    return (
      <SearchHeader>
        <HeaderSmbDescription isBackButton={showBackButton}>
          {showBackButton && <BackButton onClick={this.handleBackClick} />}
          <SMBName>{displayShipstationIcon && <ShipstationShopIcon />}</SMBName>
        </HeaderSmbDescription>
      </SearchHeader>
    );
  }
}

const mapStateToProps = (state) => {
  const searchType = getSearchTypeOfSelectedAction(state);

  return {
    selectedShop: getSelectedShop(state),
    noMatchPageActivated: extractNoMatchPageActivated(state),
    selectedToolDomains: selectSelectedToolDomains(state),
    searchType: searchType,
    showingMacroWizard: showingMacroWizard(state),
    searchId: getSearchId(state),
    selectedTicket: extractSelectedTicketFromState(state),
    selectedSearchResult: getSelectedSearchResultIndex(state),
    macroWizardCanGoBack: canMacroWizardCanGoBack(state),
    selectedConfig: getSelectedConfig(state),
    searchOrderShops: getSelectedSearchOrdersShops(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      returnToPreviousMacroWizardPath,
      clearSelectedSearchResult,
      deselectSearchOrderShops,
      clearBlockingAlertViewedIds,
    },
    dispatch
  );

export default SearchTitle = connect(mapStateToProps, mapDispatchToProps)(SearchTitle);
